import { avoidanceConstants } from 'constants/avoidance';

// It's enough to just map for single participant OR individual participants, since this is used only to pre-populate
// existing rules
export const getRuleFromPolicy = (key: string, significantCharacters?: number) => {
  switch (key) {
    case avoidanceConstants.MAPPED_PARTICIPANT_CITY:
      return avoidanceConstants.CITY;
    case avoidanceConstants.MAPPED_PARTICIPANT_STATE:
      return avoidanceConstants.STATE;
    case avoidanceConstants.MAPPED_INDIVIDUAL_PARTICIPANT_POSTAL_CODE: {
      if (significantCharacters && significantCharacters === 3) {
        return avoidanceConstants.ZIP_CODE_3;
      }
      if (significantCharacters && significantCharacters === 4) {
        return avoidanceConstants.ZIP_CODE_4;
      }
      if (significantCharacters && significantCharacters === 5) {
        return avoidanceConstants.ZIP_CODE_5;
      }
      break;
    }
    case avoidanceConstants.MAPPED_PARTICIPANT_COUNTRY:
      return avoidanceConstants.COUNTRY;
    case avoidanceConstants.MAPPED_PARTICIPANT_SECTION:
      return avoidanceConstants.SECTION;
    case avoidanceConstants.MAPPED_PARTICIPANT_DISTRICT:
      return avoidanceConstants.DISTRICT;
    default:
      return false;
  }
};

export const getDirectiveFromPolicy = (key: string) => {
  switch (key) {
    case avoidanceConstants.MAPPED_PARTICIPANT_DOUBLE_TEAM:
      return avoidanceConstants.DOUBLES_TEAM;
    case avoidanceConstants.MAPPED_PARTICIPANT_GROUP:
      return avoidanceConstants.TEAM;
    default:
      return false;
  }
};

export const isDoublesOrTeamChecked = (participant, preSelectedParticipantsIds) => {
  const individualIds = participant.individualParticipantIds;
  return individualIds?.every((id) => preSelectedParticipantsIds?.includes(id));
};
